import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-oauth-with-custom-url-and-keys',
  templateUrl: './userapi-oauth-with-custom-url-and-keys.component.html'
})
export class UserApiOAuthWithCustomUrlAndKeysComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;
}
